import React from "react";

import { GetEstadoString } from "../../othelloFunciones";
import OthelloCheckBox from "../../componentsothello/OthelloCheckBox";
import OthelloModalBase from '../../componentsothello/OthelloModalBase.jsx';

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import { ModoModal, MessageOthelloBoxButtons, DialogOthelloResult } from "../../othelloConstantes.jsx";

function EstadoPedido({...props })
{
    //variables de las propiedas recibidas
    const { idpedido, idusuario, estado, onCloseResulModal} = props;

    const [estadoactual, setEstadoActual] = React.useState(estado);   
   

    function onResulModal(modo, result, valor)
    {
        if (result == DialogOthelloResult.OK)
       {

            var jsonData = JSON.stringify({ idpedido: idpedido, idusuario: idusuario, nuevoestado: estadoactual } );
                                           
            fetch('api/Data/ActualizarEstadoPedido', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                onCloseResulModal(modo, result, valor);
            }).catch(error => {
       
            });
        }
        else
            onCloseResulModal(modo, result, valor);
    }

    function CambioEstado(nuevoestado)
    {
        if (estadoactual != nuevoestado)
            setEstadoActual(nuevoestado);
    }

    return (
        <>
            <OthelloModalBase titulo="Estado del Pedido" modo={ModoModal.SinDefinir} open={true} onCloseResulModal={onResulModal} botones={MessageOthelloBoxButtons.OK} >
                <div>                                                                     
                    <Grid container>                                          
                        <Grid item lg={12}>
                            <OthelloCheckBox label="Procesando" checked={estadoactual == 0 || estadoactual == "Procesando"} onChange={() => CambioEstado(0)} />
                        </Grid> 
                    </Grid>                                                                                                                                                        
                    <Grid container>   
                        <Grid item lg={12}>
                            <OthelloCheckBox label="Tramitado" checked={estadoactual == 1 || estadoactual == "Tramitado"} onChange={() => CambioEstado(1)}/>
                        </Grid>
                    </Grid>    
                    <Grid container>
                        <Grid item lg={12}>
                            <OthelloCheckBox label="Pendiente de Pago" checked={estadoactual == 2 || estadoactual == "Pendiente de Pago"} onChange={() => CambioEstado(2)} />
                        </Grid>
                    </Grid> 
                    <Grid container>
                        <Grid item lg={12}>
                            <OthelloCheckBox label="En Espera" checked={estadoactual == 3 || estadoactual == "En Espera"} onChange={() => CambioEstado(3)} />
                        </Grid>
                    </Grid> 
                    <Grid container>
                        <Grid item lg={12}>
                            <OthelloCheckBox label="Enviado" checked={estadoactual == 4 || estadoactual == "Enviado"} onChange={() => CambioEstado(4)} />
                        </Grid>
                    </Grid> 
                    <Grid container>
                        <Grid item lg={12}>
                            <OthelloCheckBox label="Completado" checked={estadoactual == 5 || estadoactual == "Completado"} onChange={() => CambioEstado(5)} />
                        </Grid>
                    </Grid> 
                    <Grid container>
                        <Grid item lg={12}>
                            <OthelloCheckBox label="Cancelado" checked={estadoactual == 6 || estadoactual == "Cancelado"} onChange={() => CambioEstado(6)} />
                        </Grid>
                    </Grid> 
                    <Grid container>
                        <Grid item lg={12}>
                            <OthelloCheckBox label="Reembolsado" checked={estadoactual == 7 || estadoactual == "Reembolsado"} onChange={() => CambioEstado(7)} />
                        </Grid>
                    </Grid> 
                    <Grid container>
                        <Grid item lg={12}>
                            <OthelloCheckBox label="Fallido" checked={estadoactual == 8 || estadoactual == "Fallido"} onChange={() => CambioEstado(8)} />
                        </Grid>
                    </Grid>                  
                </div>
            </OthelloModalBase>
        </>
    );
}

export default EstadoPedido;